import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../../shared/services/util.service";
import { EstadoApiService } from "../../../enderecos/estados/shared/estado-api.service";
import { Estado } from "../../../enderecos/estados/shared/estado.model";
import { editRoute, newRoute } from "../../../../shared/services/data.service";
import { OrgaoTipoApiService } from "../shared/orgao-tipo-api.service";
import { OrgaoTipoNavigationService } from "../shared/orgao-tipo-navigation.service";
import { AutoCompleteService } from "../../../../shared/components/autocomplete/autocomplete.service";
import { TipoOrgao } from "../shared/orgao-tipo.model";
import { OrgaoTipoService } from "../shared/orgao.service";
import { orgaoTiposStorage, orgaoTiposModuleName } from "../shared/data.service";

@Component({
    template: require('./orgao-tipo-form.component.html'),
    styles: [require('./orgao-tipo-form.component.css')]
})
export class OrgaoTipoFormComponent implements OnInit {
    orgaoTiposModule:any = orgaoTiposModuleName;
    formObject:any = new TipoOrgao();
    estadoObject:any = new Estado();
    actionTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;

    estadosList: Estado[] = [];

    form:FormGroup;
    ativo = new FormControl('');
    codigoTCE = new FormControl('');
    descricao = new FormControl('', Validators.required);
    estado = new FormControl('');

    private returnToOtherForm:boolean = false;
    private otherForm:string;
    private responseTipoOrgao:any;

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _orgaoTipoApiService: OrgaoTipoApiService,
        private _orgaoTipoNavigationService: OrgaoTipoNavigationService,
        private _orgaoTipoService: OrgaoTipoService,
        private _estadoApiService: EstadoApiService,
        private _autocompleteService:AutoCompleteService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            descricao: this.descricao,
            codigoTCE: this.codigoTCE,
            estado: this.estado
        });
    }

    ngOnInit() {
        this.getEstados();
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:TipoOrgao = this._utilService.cloneObject(this.formObject);

            if (this.estadoObject.id) {
                object.estadoId = this.estadoObject.id;
            } else {
                object.estadoId = null;
            }

            if (this.formObject.id) {
                this.onEditSetor(object);
            } else {
                this.onAddSetor(object);
            }
        }
    }

    private onAddSetor(object: TipoOrgao) {
        this._orgaoTipoApiService.onPost(object, this.onDone);
    }

    private onEditSetor(object: TipoOrgao) {
        this._orgaoTipoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseTipoOrgao = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum tipo de órgão encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._orgaoTipoApiService.onGetById(id, onDone);
    }

    private getEstados() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.estadosList = Response;
                this.estadosList.unshift({id: null, nome: '— Selecione —'});
                this.setEstado(null);
            }
        }.bind(this));

        this._estadoApiService.onGetAll(onDone);
    }

    private setModelToForm() {
        if (this.formObject.estadoId) {
            delete this.formObject['estado'];
            this.setEstado(this.formObject.estadoId);
        }
    }

    private setEstado(estadoId: number) {
        var x: any, lenX: any;

        if (!estadoId) {
            estadoId = this.estadosList[0].id;
        }

        for (x = 0, lenX = this.estadosList.length; x < lenX; x++) {
            if (this.estadosList[x].id === estadoId) {
                this.estadoObject = this.estadosList[x];
                break;
            }
        }
    }

    private goToList() {
        this._orgaoTipoNavigationService.goToList();
    }

    private testSession() {
        var id: number;
        var session: any = this._orgaoTipoService.getSessionStorage();
        this._orgaoTipoService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            if (id) {
                this.setEditSession();
            } else {
                this.setNewSession();
            }
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        this.setModelToForm();
    }

    private setEditSession() {
        setTimeout(function () {
            this.setModelToForm();
        }.bind(this));
    }

    private setNewSession() {
        this.setModelToForm();
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(orgaoTiposStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.descricao = newAutoComplete.descricao;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._orgaoTipoService.returnToOtherForm(this.otherForm, this.responseTipoOrgao);
        } else {
            this.goToList();
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/orgao-tipo-form/orgao-tipo-form.component.ts
 **/